export default {
  getAdminReviewList(state) {
    return state.adminReviewList;
  },

  getAdminReviewInfo(state) {
    return state.adminReviewInfo;
  },

  getPageInfo(state) {
    return state.pageInfo;
  }
};
